import { useState } from 'react'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { Icons } from '@/components/ui/Icons'
import { summarise } from './attention'
import { AttentionDialog } from './AttentionDialog'
import { useAttention } from './useAttention'

/** Top-bar button: the badge counts critical items and warnings, "to watch" items stay out of it. */
export function AttentionButton({ className }: { className?: string }) {
  const { items, loading } = useAttention()
  const [open, setOpen] = useState(false)
  const counts = summarise(items)
  const urgent = counts.critical + counts.warning

  return (
    <>
      <Button size="sm" className={className} icon={<Icons.Alert size={14} />} onClick={() => setOpen(true)} title="Open the summary of what needs attention">
        Attention
        {urgent > 0 ? (
          <Badge tone={counts.critical > 0 ? 'danger' : 'warn'}>{urgent}</Badge>
        ) : (
          !loading && (
            <Badge tone="ok" icon="circle-check" title="Nothing needs attention">
              OK
            </Badge>
          )
        )}
      </Button>
      {open && <AttentionDialog items={items} loading={loading} onClose={() => setOpen(false)} />}
    </>
  )
}
